// Others
import { IAppointment, IFormAppointment, IPayloadEditAppointment } from '~/utils/interface/appointment';
import axiosClient from './axiosClient';
import { urlApiAppointments } from '~/utils/constants/apis';
import { IBaseResponse } from '~/utils/interface/base';

const appointmentApi = {
  createAppointment: (body: IFormAppointment) => {
    const url = urlApiAppointments.createAppointment;
    return axiosClient.post<IBaseResponse>(url, body);
  },
  detailAppointment: (appointmentId: string) => {
    const url = urlApiAppointments.detailAppointment(appointmentId);
    return axiosClient.get<IBaseResponse<IAppointment>>(url);
  },
  updateAppointment: (payload: IPayloadEditAppointment) => {
    const { appointmentId, body } = payload;
    const url = urlApiAppointments.updateAppointment(appointmentId);
    return axiosClient.put<IBaseResponse>(url, body);
  },
};

export default appointmentApi;
